export default {"src":"/_next/static/media/gfc.d9424035.svg","height":59,"width":158,"blurWidth":0,"blurHeight":0};